import { Autocomplete, FormControlLabel, IconButton } from '@mui/material'
import React from 'react'
import {
  CustomInput,
  CustomSelect,
  CustomTextArea,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { DeleteIcon, DosageWidth } from './styledComponents'
import Add from '@mui/icons-material/Add'
import { StyledLabel } from 'src/consumer/components/helperComponentsStyles'
import {
  appliedWhereOptions,
  frequencyOptions,
  timingOptions,
  unitOptions,
  whatTimeOptions,
} from 'src/consumer/constants'

export default function DrugEditComponent({
  initialObject = {},
  medicineObject,
  setMedicineObject,
  handleChangeObject,
  disabled = false,
}) {
  const dosageArray = medicineObject.dosage.split('-')

  function dosageChange(e, idx) {
    const finalDosageValue = dosageArray.map((d, index) => {
      return idx === index ? e.target.value : d
    })
    handleChangeObject({ target: { id: 'dosage', value: finalDosageValue.join('-') } })
  }

  function deleteDosage(idx) {
    const finalDosageValue = dosageArray.filter((d, index) => idx !== index)
    handleChangeObject({ target: { id: 'dosage', value: finalDosageValue.join('-') } })
  }

  function addDosage() {
    const finalDosageValue = [...(dosageArray || []), '']
    handleChangeObject({ target: { id: 'dosage', value: finalDosageValue.join('-') } })
  }

  function handleChangeWhatTime(e, newValue) {
    setMedicineObject((prev) => ({ ...prev, whatTime: newValue }))
  }
  function handleChangeAppliedWhere(e, newValue) {
    setMedicineObject((prev) => ({ ...prev, appliedWhere: newValue }))
  }
  function handleChangeTiming(e, newValue) {
    setMedicineObject((prev) => ({ ...prev, timing: newValue }))
  }

  return (
    <div className="row g-2">
      <div className="col-md-5">
        <CustomInput
          id="name"
          label="Medicine Name"
          value={medicineObject.name}
          onChange={handleChangeObject}
          placeholder="Enter a medicine name...."
          required
        />
      </div>
      <div className="col-md-7 d-flex flex-column gap-2">
        <StyledLabel>Dosage</StyledLabel>
        <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
          {dosageArray.map((dosage, idx) => (
            <React.Fragment key={idx}>
              <DosageWidth>
                {dosageArray.length > 1 && <DeleteIcon onClick={() => deleteDosage(idx)} />}
                <CustomInput value={dosage} onChange={(e) => dosageChange(e, idx)} />
              </DosageWidth>
              {idx !== dosageArray.length - 1 && <div>-</div>}
            </React.Fragment>
          ))}
          <div>-</div>
          <IconButton onClick={addDosage}>
            <Add />
          </IconButton>
        </div>
      </div>
      <div className="col-md-2">
        <CustomSelect
          id="unit"
          value={!!medicineObject.unit ? medicineObject.unit : null}
          onChangeEvent={handleChangeObject}
          selectType={selectTypes.string}
          label="Unit"
          options={unitOptions}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
        />
      </div>
      <div className="col-md-2">
        <CustomSelect
          id="timing"
          value={!!medicineObject.timing ? medicineObject.timing : null}
          onChangeEvent={handleChangeObject}
          selectType={selectTypes.string}
          label="Time"
          options={timingOptions}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
        />
        {/* <Autocomplete
            id="timing"
            inputValue={medicineObject.timing}
            onInputChange={handleChangeTiming}
            freeSolo
            options={timingOptions
              ?.filter((optn) => !isNaN(medicineObject.timing))
              ?.map(
                (option) =>
                  `${medicineObject.timing} ${option.title}${
                    !isNaN(medicineObject.timing) && Number(medicineObject.timing) > 1 ? 's' : ''
                  }`,
              )}
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <CFormInput {...params.inputProps} label="Timing" />
              </div>
            )}
          /> */}
      </div>
      <div className="col-md-4">
        <Autocomplete
          id="whatTime"
          inputValue={medicineObject.whatTime}
          onInputChange={handleChangeWhatTime}
          freeSolo
          options={whatTimeOptions.map((option) => option?.title)}
          // renderOption={}
          renderInput={(params) => (
            <div ref={params.InputProps.ref}>
              <CustomInput
                pureInputProps={params.inputProps}
                label="When"
                placeholder="When to take the medicine....."
              />
            </div>
          )}
        />
      </div>
      <div className="col-md-4">
        <Autocomplete
          id="appliedWhere"
          inputValue={medicineObject.appliedWhere}
          onInputChange={handleChangeAppliedWhere}
          freeSolo
          options={appliedWhereOptions.map((option) => option.title)}
          renderInput={(params) => (
            <div ref={params.InputProps.ref}>
              <CustomInput
                pureInputProps={params.inputProps}
                label="Applied Where"
                placeholder="Where to apply the medicine....."
              />
            </div>
          )}
        />
      </div>
      <div className="col-md-4">
        <CustomTextArea
          id="genericName"
          minHeight={15}
          label="Generic Name"
          placeholder="Enter the general name for this medicine..."
          value={medicineObject.genericName}
          onChange={handleChangeObject}
        />
      </div>
      <div className="col-md-4">
        <CustomSelect
          id="frequency"
          value={!!medicineObject.frequency ? medicineObject.frequency : null}
          onChangeEvent={handleChangeObject}
          selectType={selectTypes.string}
          label="Frequency"
          placeholder="How often to have the medicine...."
          options={frequencyOptions}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
        />
      </div>
      <div className="col-md-1">
        <CustomInput
          id="qty"
          label="Qty"
          value={medicineObject.qty}
          placeholder="Qty to take..."
          // type="number"
          onChange={handleChangeObject}
        />
      </div>
      <div className="col-md-3">
        <CustomTextArea
          id="note"
          label="Notes"
          placeholder="eg.To continue..."
          value={medicineObject.note}
          minHeight={15}
          // type="number"
          onChange={handleChangeObject}
        />
      </div>
    </div>
  )
}
